import React from 'react';
import { motion } from 'framer-motion';
import Bg from '../../images/ui/dark-blue-bg.jpg';
import VideoBg from '../../video/blue-bg.mp4';
import Head from '../../images/evidence/speech-understanding-head.png';
import Speakers from '../../images/evidence/speech-understanding-speakers.png';
import MagentaLine from '../elements/MagentaLine';

export default function SpeechUnderstanding() {
  const BASE_TIME = 2.2;
  return (
    <div className="evidence-subpage" id="speech-understanding">
      <img src={Bg} className="full-bg" />
      <motion.video
        src={VideoBg}
        className="full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="97px" left="18px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '18px',
              top: '26px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Evidence
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '22px',
              top: '70px',
              letterSpacing: '0.8px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            Test Setup: Speech Understanding
          </motion.div>
        </div>
      </header>
      <motion.img
        src={Head}
        id="su-head"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 4.4 }}
      />
      <motion.img
        src={Speakers}
        id="speakers"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 4.4 }}
      />
      <motion.div
        id="purpose-block"
        className="text-block"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 0.4 }}
      >
        <div className="label" id="purpose">
          Purpose
        </div>
        <p>
          Investigate speech understanding in noise using a standard matrix
          sentence test with Oticon More™, compared to Opn S™
        </p>
      </motion.div>

      <motion.div
        id="participants-block"
        className="text-block"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 1 }}
      >
        <div className="label" id="participants">
          Participants
        </div>
        <ul>
          <li>Eighteen experienced hearing-aid users</li>
          <li>Age range 52-77 years</li>
          <li>Hearing losses within the 85dB speaker level range</li>
        </ul>
      </motion.div>

      <motion.div
        id="conditions-block"
        className="text-block"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 1.6 }}
      >
        <div className="label" id="conditions">
          Conditions
        </div>
        <ul>
          <li>Oticon More with default fitting settings</li>
          <li>Oticon Opn S with default fitting settings</li>
        </ul>
      </motion.div>
    </div>
  );
}
